@if (hasNotifications()) {
  <div
    class="notification-container pointer-events-none absolute right-0 bottom-0 z-50 w-full max-w-xs pr-1.5">
    <div class="pointer-events-auto flex flex-col space-y-3">
      @for (notification of notifications(); track notification.id) {
        <app-notification
          (dismiss)="onDismiss($event)"
          (pauseEvent)="onPause($event)"
          (resumeEvent)="onResume($event)"
          [notification]="notification" />
      }
    </div>
  </div>
}
